<div class="priceListPage"  [ngStyle]="isMobile ? {'margin': '12px -15px 0px -15px '} : {'margin': '0px -15px 0px -15px'}">
  <div class="nplPage priceListPageClass-wrapper" style="width: 100%; margin:0;">
    <div class="priceLists margin-0">
      <div class="topSection">
        <div class="alignTopSec">
          <div class="order-view-sec breadcrumbOuter padding-0" id="orderView1" [ngClass]="'col-md-12'" *ngIf="!isMobile">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item active">
                  <a href="javascript:void(0)" routerLink="/cpp/customer-price-list">Price Lists</a>
                  <!--<i class="fas fa-angle-right"></i>-->
                </li>
                <!--<li class="breadcrumb-item breadcrumbColor">
                  <span>Customer Price List</span>
                </li>-->
              </ol>
            </nav>
          </div>
          <div class="row" *ngIf="isMobile">
            <div class="col-md-12 col-lg-12 margin-l0 cppTopSec">
              <h3>
                CPP Price Lookup
              </h3>
            </div>
          </div>
          <div class="form-sec">
            <div class="row margin-b10 margin-r0 margin-l0 ">
              <div class="col-sm-12 col-md-12 col-lg-12 smallPadRgt0 padding-l0">
                <div class="row search-box-outer ">
                  <div [ngClass]="isMobile ? 'col-md-3 col-lg-2 border-rt' : 'col-md-3 col-lg-2 padding-t20 border-rt'">
                    <div class="category-dropdown material-select" *ngIf="!isMobile">
                      <span>Customer Name</span>
                    </div>
                  </div>
                  <div class="col-md-9 col-lg-10 padding-0 padding-l4">
                    <div class="row material-select reports-search-filter">
                      <ng-select #AccountNo *ngIf="selectedValue === 'Customer Name'"
                                 [items]="priceListAccounts"
                                 [placeholder]="!isMobile ? 'Search Price Lists' : 'Search Retailer'"
                                 class="custom-select-grower"
                                 [multiple]="false"
                                 [hideSelected]="true"
                                 [(ngModel)]="searchAccountNo"
                                 [virtualScroll]="true"
                                 bindLabel="accountName"
                                 bindValue="accountNumber"
                                 [closeOnSelect]="true"
                                 [searchFn]="accountSearchFn"
                                 (change)="filterRecords()">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                          <div class="dropdown-template">
                            <div class="row">
                              <div class="col-md-8">
                                <h4 class="name greenColor" [ngOptionHighlight]="search">
                                  {{item.accountName}}
                                </h4>
                                <p class="grower-nos">
                                  <span class="grower-gln" [ngOptionHighlight]="search">
                                    Account #: {{item.accountNumber}}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                          <div class="ng-option disabled">
                            No data found for "{{searchTerm}}"
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottomSection">
        <div class="row">
          <div class="col-md-12 productTableOuter">
            <div class="tableContainer priceListTable" id="cppOrderView">
              <table mat-table #placedCPPOrdersTable [dataSource]="CPPPricedListDataSource" multiTemplateDataRows class="matTables">
                <ng-container matColumnDef="{{column}}" *ngFor="let column of priceListCPPColumns">
                  <div *ngIf="column=='Customer'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">{{headerValue}}</th>
            </div>
            <div *ngIf="column=='contextMenu'"><th mat-header-cell *matHeaderCellDef class="detailsTable text-right">&nbsp;</th></div>
            <td mat-cell *matCellDef="let element">
              <div *ngIf="column=='Customer'">
                <div class="order-info">
                  <span (click)="redirectToProduct(element.accountNumber,element.accountName);">
                    <p class="itemName">
                      {{element.accountName}}
                    </p>
                  </span>
                </div>
              </div>
              <div *ngIf="column=='contextMenu' && !isMobile">
                <div class="text-right">
                  <button mat-button class="context-menu" disableRipple [matMenuTriggerFor]="beforeMenu1" matTooltip="" [matTooltipPosition]="'above'">
                    <i class="fas fa-ellipsis-v margin-l15"></i>
                    <mat-menu #beforeMenu1="matMenu" xPosition="after" class="context-meun-dropdown">
                      <button mat-menu-item (click)="redirectToProduct(element.accountNumber,element.accountName);">View Price List</button>
                      <button *ngIf="isManageSubscription" mat-menu-item (click)="redirectToSubscription(element.accountNumber,element.accountName);">Subscriptions</button>
                    </mat-menu>
                  </button>
                  <!--<span class="margin-l5 thirdOne context-menu" mat-button [matMenuTriggerFor]="beforeMenu1" matTooltip="Export Selected Products" [matTooltipPosition]="'above'">
                    <i class="fas fa-download"></i>
                  </span>-->
                  <!--<button mat-button (click)="redirectToProduct(element.accountNumber,element.accountName);" class="context-menu" disableRipple>
                    <i class="fas fa-ellipsis-v"></i>
                  </button>-->
                </div>
              </div>
            </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="priceListCPPColumns;sticky:true;"></tr>
            <tr mat-row *matRowDef="let element; columns: priceListCPPColumns;"></tr>
            </table>
            <div *ngIf="CPPPricedListDataSource == undefined || CPPPricedListDataSource?.data.length == 0" class="noDataMsg">
              <p>{{emptyGridMsg}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
